__turbopack_context__.v({
  "actions": "Layout-module-scss-module__G7sWEG__actions",
  "buildDetails": "Layout-module-scss-module__G7sWEG__buildDetails",
  "card": "Layout-module-scss-module__G7sWEG__card" + " " + "Layout-module-scss-module__G7sWEG__content",
  "container": "Layout-module-scss-module__G7sWEG__container",
  "content": "Layout-module-scss-module__G7sWEG__content",
  "error": "Layout-module-scss-module__G7sWEG__error",
  "footer": "Layout-module-scss-module__G7sWEG__footer",
  "header": "Layout-module-scss-module__G7sWEG__header",
  "hidden": "Layout-module-scss-module__G7sWEG__hidden",
  "isCreateAccount": "Layout-module-scss-module__G7sWEG__isCreateAccount",
  "isWide": "Layout-module-scss-module__G7sWEG__isWide",
  "layoutHeader": "Layout-module-scss-module__G7sWEG__layoutHeader",
  "line-break": "Layout-module-scss-module__G7sWEG__line-break",
  "main": "Layout-module-scss-module__G7sWEG__main",
  "subheader": "Layout-module-scss-module__G7sWEG__subheader",
  "text-align_center": "Layout-module-scss-module__G7sWEG__text-align_center",
});
